import React, { useState, useEffect } from "react";
import { useLocation, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import useFetch from "../../../../context/useFetch";
import moment from "jalali-moment";

const AdminPrintOrderDetailsByBangle = (props) => {
  const [ordersDetail, setOrdersDetail] = useState({
    results: [],
    detail: [],
  });
  const { id } = useParams();
  const location = useLocation();

  const getOrderDetailsApi = useFetch({
    method: "get",
    url: `Bangle_Service/${id}/admin_get_order_item_detail_from_order_using_bangle`,
    trigger: true,
    setter: setOrdersDetail,
    params: { admin_change_item: true, status: location.state.status },
    argFunc: (res) => {},
    errMessage: (mess) => {
      toast.error("خطایی رخ داده است", {
        position: toast.POSITION.TOP_CENTER,
      });
    },
  });

  return (
    <>
      <div className="panel-main-header mt-3 mr-2">
        <span>چاپ مشخصات سفارش بر اساس النگو</span>
      </div>

      {/* <div className="mr-4">
        <span className="text-sm text-myblue-100">
          {ordersDetail.results[0]?.bangle?.show_name}/
        </span>
        <span className="text-sm text-myblue-100">
          {ordersDetail.results[0]?.bangle?.brand_name}/
        </span>
        <span className="text-sm text-myblue-100">
          {ordersDetail.results[0]?.bangle?.gender == "woman"
            ? "زنانه"
            : "بچه گانه"}
          /
        </span>
        <span className="text-sm text-myblue-100">
          {ordersDetail.results[0]?.bangle?.color == "yellow" ? "زرد" : "سفید"}
        </span>
      </div> */}

      <div className="printTable mr-2 ml-2">
        <div className="border rounded-md mt-4 overflow-hidden">
          <div className="flex justify-between">
            <div className="basis-1/2  text-center py-1 ">
              <span className="text-sm text-myblue-100">ردیف</span>
            </div>

            <div className="basis-1/2  text-center py-1 border-r ">
              <span className="text-sm text-myblue-100">مشتری</span>
            </div>
            <div className="basis-1/2  text-center py-1 border-r ">
              <span className="text-sm text-myblue-100">تاریخ ثبت سفارش</span>
            </div>
            <div className="basis-1/2  text-center py-1 border-r ">
              <span className="text-sm text-myblue-100">وزن</span>
            </div>
            {/* <div className="basis-1/2  text-center py-1 border-r ">
              <span className="text-sm text-myblue-100"> وضعیت </span>
            </div> */}
            <div className="basis-1/2  text-center py-1 border-r ">
              <span className="text-sm text-myblue-100">النگو</span>
            </div>
            <div className="basis-1/2  text-center py-1 border-r ">
              <span className="text-sm text-myblue-100"> برند</span>
            </div>
            <div className="basis-1/2  text-center py-1 border-r ">
              <span className="text-sm text-myblue-100"> سن</span>
            </div>
            <div className="basis-1/2  text-center py-1 border-r ">
              <span className="text-sm text-myblue-100"> رنگ</span>
            </div>
            {/* <div className="basis-1/2  text-center py-1 border-r ">
                <span className="text-sm text-myblue-100"> تاریخ</span>
              </div> */}
            <div className="basis-1/2  text-center py-1 border-r ">
              <span className="text-sm text-myblue-100"> یک</span>
            </div>
            <div className="basis-1/2  text-center py-1 border-r ">
              <span className="text-sm text-myblue-100"> دو</span>
            </div>
            <div className="basis-1/2  text-center py-1 border-r ">
              <span className="text-sm text-myblue-100">سه</span>
            </div>
            <div className="basis-1/2  text-center py-1 border-r ">
              <span className="text-sm text-myblue-100"> چهار</span>
            </div>
            <div className="basis-1/2  text-center py-1 border-r ">
              <span className="text-sm text-myblue-100"> پنج</span>
            </div>
            <div className="basis-1/2  text-center py-1 border-r ">
              <span className="text-sm text-myblue-100"> شش</span>
            </div>
          </div>

          {ordersDetail.results.map((item, index) => {
            return [
              <>
                <div className="printTableTr flex justify-between">
                  <div className="basis-1/2 border-t  text-center py-1">
                    <span className="text-sm text-myblue-100">{index + 1}</span>
                  </div>

                  <div className="basis-1/2  border-t text-center py-1 border-r ">
                    <span className="text-sm text-myblue-100">
                      {item.store_name}
                    </span>
                  </div>
                  <div className="basis-1/2  border-t text-center py-1 border-r ">
                    <span className="text-sm text-myblue-100">
                      
                      {item.created_at !== null &&
                        moment(item.created_at, "YYYY/MM/DD")
                          .locale("fa")
                          .format("YYYY/MM/DD")}
                    </span>
                  </div>
                  <div className="basis-1/2  border-t text-center py-1 border-r ">
                    <span className="text-sm text-myblue-100">
                      {item.total}
                    </span>
                  </div>

                  <div className="basis-1/2  border-t text-center py-1 border-r ">
                    <span className="text-sm text-myblue-100">
                      {item.bangle.show_name}
                    </span>
                  </div>
                  <div className="basis-1/2  border-t text-center py-1 border-r ">
                    <span className="text-sm text-myblue-100">
                      {item.bangle.brand_name}
                    </span>
                  </div>
                  <div className="basis-1/2  border-t text-center py-1 border-r ">
                    <span className="text-sm text-myblue-100">
                      {item.bangle.gender == "woman" ? "زنانه" : "بچه گانه"}
                    </span>
                  </div>
                  <div className="basis-1/2  border-t text-center py-1 border-r ">
                    <span className="text-sm text-myblue-100">
                      {item.color == "yellow" ? "زرد" : "سفید"}
                    </span>
                  </div>
                  <div className="basis-1/2  border-t text-center py-1 border-r ">
                    <span className="text-sm text-myblue-100">
                      {item.admin_size_one_num}
                    </span>
                  </div>
                  <div className="basis-1/2  border-t text-center py-1 border-r ">
                    <span className="text-sm text-myblue-100">
                      {item.admin_size_two_num}
                    </span>
                  </div>
                  <div className=" basis-1/2 border-t text-center py-1 border-r">
                    <span className="text-sm text-myblue-100">
                      {item.admin_size_three_num}
                    </span>
                  </div>
                  <div className="basis-1/2  border-t text-center py-1 border-r ">
                    <span className="text-sm text-myblue-100">
                      {item.admin_size_four_num}
                    </span>
                  </div>
                  <div className="basis-1/2  border-t text-center py-1 border-r ">
                    <span className="text-sm text-myblue-100">
                      {item.admin_size_five_num}
                    </span>
                  </div>
                  <div className=" basis-1/2 border-t text-center py-1 border-r">
                    <span className="text-sm text-myblue-100">
                      {item.admin_size_six_num}
                    </span>
                  </div>
                </div>
              </>,
            ];
          })}
        </div>
      </div>
    </>
  );
};

export default AdminPrintOrderDetailsByBangle;
